import { useSelector } from 'react-redux'
import { NlpProviderType } from '@feedyou-ai/feedbot-schema'
import { DefaultPromptsDictionary } from '@feedyou/schema'

import { defaultPromptsSelector } from '../selectors/defaultPromptsSelector'
import { useBotDefaultLocale } from '../../../store/flow'

export function useDefaultPrompts(): DefaultPromptsDictionary | undefined {
  return useSelector(defaultPromptsSelector)
}

function resolveLocale(
  modelLocale: string | undefined,
  botDefaultLocale: string | undefined
): string {
  if (modelLocale && modelLocale !== 'default') {
    return modelLocale
  }
  return botDefaultLocale || 'en'
}

export function useDefaultPromptForProvider(
  providerType: NlpProviderType | undefined,
  modelLocale?: string,
  mode?: string
): string | undefined {
  const defaultPromptsDictionary = useDefaultPrompts()
  const botDefaultLocale = useBotDefaultLocale()

  if (!defaultPromptsDictionary || !providerType) {
    return undefined
  }

  const locale = resolveLocale(modelLocale, botDefaultLocale)
  const defaultPrompts = defaultPromptsDictionary[locale] ?? defaultPromptsDictionary['en']

  if (!defaultPrompts) {
    return undefined
  }

  switch (providerType) {
    case 'kb-chat':
    case 'openai-chat':
      return defaultPrompts.kbChat
    case 'llm-classifier':
      return mode?.startsWith('function')
        ? defaultPrompts.llmClassifierFunction
        : defaultPrompts.llmClassifierText
    default:
      return undefined
  }
}
